import * as React from 'react'
import { useHistory } from 'react-router-dom';
import { Body } from '../../components/templates/Wrappers';

export const RedirectPage: React.FC<{ target: string }> = ({ target }) => {
  const history = useHistory()
  React.useEffect(() => {
    history.push(target)
  }, [])
  return (
    <Body>
      <div style={{ textAlign: 'center' }}>
        <code>Redirect to: [{target}]</code>
      </div>
    </Body>
  )
};
